import { useState } from 'react';

enum E_MENU_STATE {
  OPEN = 'open',
  CLOSING = 'closing',
  CLOSED = 'closed',
}

export const useHeaderMenu = () => {
  const [menuState, setMenuState] = useState<E_MENU_STATE>(E_MENU_STATE.CLOSED);

  const onMenuToggle = () => {
    if (menuState === E_MENU_STATE.OPEN) {
      setMenuState(E_MENU_STATE.CLOSING);
    } else {
      setMenuState(E_MENU_STATE.OPEN);
    }
  };

  const onMenuClose = () => {
    if (menuState === E_MENU_STATE.OPEN) {
      setMenuState(E_MENU_STATE.CLOSING);
    }
  };

  const onAnimationEnd = () => {
    if (menuState === E_MENU_STATE.CLOSING) {
      setMenuState(E_MENU_STATE.CLOSED);
    }
  };

  return {
    isMenuOpen: menuState === E_MENU_STATE.OPEN,
    isMenuClosing: menuState === E_MENU_STATE.CLOSING,
    onMenuToggle,
    onMenuClose,
    onAnimationEnd,
  };
};
